import * as React from 'react';
import { Metadata } from '../../../../types/Metadata';
import { FieldType } from '../../../../enums/FieldType';
import { getEmployeeName, getMetadata, isAuditType } from '../../../../utils';
import { ItemFieldProps } from './types';
import { Field, getValue } from './field';

export const ItemField = ({ item, fieldInfo, itemSchema }: ItemFieldProps) => {
  const { schemaField, referenceSchema, field, schema, schemaType } = fieldInfo;
  let { name, displayName, fieldType, relationType, dataType, parentField } =
    schemaField;
  if (schema.props.type == itemSchema.props.type) {
    if (fieldType != FieldType.reference) {
      return (
        <Field
          label={name}
          value={getValue(item, field, schemaField)}
          fieldInfo={fieldInfo}
        />
      );
    } else if (fieldType == FieldType.reference && referenceSchema) {
      const metadata = item.props[field];
      if (!metadata?.length) return null;
      const df = referenceSchema.props.displayField;
      const getValues = (m: Metadata) => {
        if (isAuditType(relationType))
          return [getEmployeeName(m, { withAudit: true })];
        return [m.props[df]];
      };
      return metadata.map((m: Metadata) => (
        <Field
          key={m.id}
          labels={m.labels}
          values={getValues(m)}
          fieldInfo={fieldInfo}
        />
      ));
    }
  } else {
    const metadata = getMetadata(item.metadata, schema.props.type);
    if (!metadata?.length) return null;
    let data = { label: displayName, values: [] };
    if (fieldType != FieldType.reference) {
      if (schema.props.displayField == field) data.label = schema.props.name;
      data.values = removeDuplicates(metadata).map(m =>
        getValue(m, field, schemaField)
      );
    } else if (fieldType == FieldType.reference && referenceSchema) {
      const df = referenceSchema.props.displayField;
      const list = metadata?.reduce<Metadata[]>((arr, m) => {
        if (m?.props && m.props[field] && m.props[field].length) {
          m.props[field].forEach(d => {
            arr.push(d);
          });
        }
        return arr;
      }, []);
      data.label = name;
      data.values = removeDuplicates(list).map(m =>
        getValue(m, df, schemaField)
      );
    }
    if (!data.values.length) return null;
    return <Field {...data} fieldInfo={fieldInfo} />;
  }
  console.log('Field display not implemented', schemaField);
  return null;
};

const removeDuplicates = (ms: Metadata[]) => {
  const getIndex = (m: Metadata) => {
    for (let i = 0; i < ms.length; i++) {
      if (m.id == ms[i].id) return i;
    }
  };
  return ms.filter((m, i) => getIndex(m) == i);
};
